import {PIXI} from '@colonist/pixi'
import {GameStateEnums} from '../../../../../../shared/GameEnums'
import {UIUtilsEjsVariables} from '../../../UIUtilsEjsVariables'
import {UIGameManager} from '../../UIGameManager'
import {UIGameMapHighlightController} from './UIGameMapHighlightController'
import {UIGameMapHighlightParameters} from '../UIGameMapHighlightView'
import {UIGameActionConfirmationParameters} from '../../ui_game_hover_actions/UIHoverActionController'
import {getMerchantImageNameForPlayer, Sprites} from '../../UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../../UIGameSpriteHandler'
import {HexFace} from '@colonist/game-mechanic-validators'
import {ActionState} from '@colonist/game-states'
import {robberSkinController} from '../../UIGameRobberSkinController'

export class UIGameMapTileCenterHighlightController extends UIGameMapHighlightController {
    private tiles: number[]

    constructor(uiGameManager: UIGameManager) {
        super(uiGameManager)
        this.tiles = []
    }

    onEvent(data: any, eventType: GameStateEnums.UIGameEventEnums): void {
        super.onEvent(data, eventType)
        switch(eventType) {
            case GameStateEnums.UIGameEventEnums.SetTileHighlight: this.setTiles(data); break
            default: break
        }
    }

    private setTiles(highlightedIndexes: number[]) {
        this.tiles = this.tiles.concat(highlightedIndexes)
        if(highlightedIndexes.length == 0) this.tiles = []
        this.updateHighlights()
    }

    protected updateHighlights() {
        this.removeHighlights()

        if(this.tiles.length > 0) this.confirmActionController.setupInvisibleBackground(() => this.startAnimation())

        for(const tileIndex of this.tiles) {
            this.highlightTile(this.uiGameManager.gameState.mapState.tileState.tiles[tileIndex].hexFace, tileIndex)
        }

        if(this.highlightViews.length > 0) this.startAnimation()
    }

    private highlightTile(face: HexFace, tileIndex: number) {
        const robberCircle = this.uiGameManager.mapController.mapView.getTileLeftCenterCircle(face)
        const size = robberCircle.radius * 2.5 * this.circlesScaleForMobile
        if(UIUtilsEjsVariables.isUserOnMobile) {
            robberCircle.y += (this.uiGameManager.mapController.mapView.hexagonHeight / 6)
        }

        const highlightAction = this.getHighlightAction(tileIndex, robberCircle, size)
        const highlightParameters: UIGameMapHighlightParameters = {
            x: robberCircle.x - size / 2,
            y: robberCircle.y - size / 2,
            size: size,
            index: tileIndex,
        }
        this.highlight(highlightParameters, highlightAction)
    }

    private getHighlightAction(tileIndex: number, robberCircle: PIXI.Circle, size: number) {
        return () => {
            if(this.uiGameManager.gameController.myActionState == ActionState.SelectKnightAction) {
                this.uiGameManager.socketGameSend.selectedTile(tileIndex)
                return
            }
            this.endAnimation()

            const highlightParameters: UIGameMapHighlightParameters = {
                x: robberCircle.x - size / 2,
                y: robberCircle.y - size / 2,
                size: size,
                index: tileIndex,
            }

            const buttonSize = highlightParameters.size * this.buttonScaleForMobile
            const highlightCenter = new PIXI.Point(highlightParameters.x + highlightParameters.size / 2, highlightParameters.y + highlightParameters.size / 2)
            const buttonX = highlightCenter.x - buttonSize / 2
            const buttonY = highlightCenter.y - buttonSize * 1.5
            const cancelAction = () => this.startAnimation()

            const confirmationParameters: UIGameActionConfirmationParameters[] = this.getConfirmationParameters(tileIndex)
            this.confirmActionController.showActionConfirmation(highlightParameters, buttonX, buttonY, buttonSize, cancelAction, confirmationParameters, tileIndex)
        }
    }

    private getConfirmationParameters(tileIndex: number): UIGameActionConfirmationParameters[] {
        const confirmationParameters: UIGameActionConfirmationParameters[] = []
        confirmationParameters.push({
            texture: this.getHighlightActionTexture(tileIndex),
            canTakeAction: true,
            action: (placementIndex: number) => {
                if(!this.isAllowedPlacementIndex(tileIndex)) return this.uiGameManager.eventController.sendEvent(undefined, GameStateEnums.UIGameEventEnums.BeginnerModeForceOpenGuideBubble)
                this.uiGameManager.socketGameSend.selectedTile(placementIndex)
            },
            bankActionAmount: undefined,
            resourcesToBuild: [],
        })
        return confirmationParameters
    }

    private getHighlightActionTexture(tileIndex: number): PIXI.Texture {
        if(this.uiGameManager.gameController.myActionState == ActionState.PlaceMerchant) {
            const merchantTextureName = getMerchantImageNameForPlayer(this.uiGameManager.gameController.myColor)
            const merchantTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites[merchantTextureName])
            return merchantTexture
        }
        const isTileLand = this.uiGameManager.gameState.mapState.tileState.tiles[tileIndex].isTileLand()
        return isTileLand ? UIGameSpriteHandler.getTextureFromSpritesheet(robberSkinController.getRobberSkin()) : UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_pirate_ship)
    }
}
